import axios from "axios";
import { getApiBaseUrl } from "../utils/runtimeUrls";

const api = axios.create({
	baseURL: getApiBaseUrl(),
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: getApiBaseUrl()
});

export default api;
